import { useCallback } from "react";
import { dispatchAppEvent } from "./app-events";

// Shared prop wiring for <Header/> on every standalone route that renders
// its own header outside of AppContent's FeedLayout (PostDetailPage, and now
// the Listen pages) — see app-events.ts for why this is event-based.
export function useAppHeaderProps() {
  const onOpenAuth = useCallback((mode?: string) => dispatchAppEvent("inspirelens:openAuth", mode), []);
  const onOpenCreateModal = useCallback(() => dispatchAppEvent("inspirelens:openCreateModal"), []);
  return { onOpenAuth, onOpenCreateModal };
}
